
import React from 'react'

interface Props {
  title: string
}

const ContentHeaderTitle = ({ title }: Props) => {

  return (
    <div className="ul-widget__head-label flex-grow-1">
      <h3 className="ul-widget__head-title">
        {title}
      </h3>
    </div>
  )
}

export default ContentHeaderTitle
